import "./assessment.css";
import { getUserAssessmentRecords } from "../../../services/schemeApiService/SchemeApiService";
import { useEffect, useState } from "react";
import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";

const AssessmentReportsPage = () => {
  const [assessmentRecords, setAssessmentRecords] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(10);

  const fetchAssessmentRecord = async (value = "", page = 1) => {
    try {
      const response = await getUserAssessmentRecords(
        value,
        page,
        pageSize
      );

      const data = response?.data?.data;
      setAssessmentRecords(data?.items || []);
      setTotalPages(data?.pagination?.totalPages || 1);
      setCurrentPage(data?.pagination?.page || 1);

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAssessmentRecord(searchValue, currentPage);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setCurrentPage(1);
      fetchAssessmentRecord(searchValue, 1);
    }, 300);

    return () => clearTimeout(delayDebounce);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  /* PUT THIS FUNCTION HERE (Before return) */
  const formatAnswer = (ans) => {

    // multichoice / checkbox / select
    if (["multichoice", "checkbox", "select"].includes(ans?.type)) {

      const selected = ans?.selectedOptions?.length
        ? ans.selectedOptions?.join(", ")
        : "";

      const other = ans?.otherValue || "";

      return [selected, other]?.filter(Boolean)?.join(", ") || "-";
    }

    // date format
    if (ans?.type === "date" && ans?.answerText) {
      const date = new Date(ans.answerText);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    }

    // file type
    if (ans?.type === "file" && ans?.answerText) {
      try {
        const files = JSON.parse(ans?.answerText);

        return files?.map((file, i) => (
          <a
            key={i}
            href={`${process.env.REACT_APP_NEXT_PUBLIC_IMAGE_UPLOAD_URL}${file}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'var(--bs-link-color)',
              textDecoration: 'underline'
            }}
          >
            {i>0 && ','} view file
          </a >
        ));
      } catch {
        return "-";
      }
    }

    // other types (text, textarea, date, time etc.)
    return ans?.answerText || "-";
  };

  return (
    <div className="ar-container">
      <h2 className="ar-page-title">Assessment Reports</h2>

      <div className="ar-main-wrapper">
        <h4 className="ar-section-title">Basic Athletes Details</h4>

        <div className="ar-search-wrapper">
          <input
            type="text"
            className="ar-search-input"
            placeholder="Search name...."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        {assessmentRecords.length === 0 ? (
          <div className="ar-no-data">
            <p>No Data Found</p>
          </div>
        ) : (
          assessmentRecords?.map((item) => {
            return (
              <div key={item?.submissionId} className="ar-assessment-block">
                <h5 className="ar-assessment-title">
                  {item?.formTitle}
                </h5>

                <div className="ar-table-scroll">
                  <table className="ar-custom-table">
                    <thead className="ar-table-header">
                      <tr>
                        {item?.answers?.map((ans, i) => (
                          <th key={i} className="ar-th">
                            {ans?.questionText || `Question-${i + 1}`}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        {item.answers.map((ans, i) => (
                          <td key={i} className="ar-td">
                            {formatAnswer(ans)}   {/* :white_check_mark: USE IT HERE */}
                          </td>
                        ))}
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            );
          })
        )}

        <div className="d-flex justify-content-center py-2">
          <PaginationComp
            size={totalPages}
            currentpage={currentPage}
            setCurrentPage={(page) => {
              setCurrentPage(page);
              fetchAssessmentRecord(searchValue, page);
            }}
            gutter={true}
            variant=""
            bg={true}
            circle={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AssessmentReportsPage;